function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.26 1.503h1.11c.01-.331.236-.55.565-.55.32 0 .546.192.546.468 0 .301-.12.445-.584.718-.475.274-.646.581-.581 1.166l.01.136h1.067v-.16c0-.322.13-.475.598-.745.502-.29.738-.64.738-1.145 0-.82-.677-1.368-1.716-1.368-1.094 0-1.743.585-1.753 1.48zM8.89 5.12c-.44 0-.7-.23-.7-.622 0-.397.26-.626.7-.626.441 0 .697.23.697.626 0 .393-.256.622-.697.622zm-7.363.124v2.45a1.75 1.75 0 003.375.887l1.06 1.212a3.25 3.25 0 11-4.435-4.548zM2.5 6.257V4H4v1.75h2.115l2.221 2.782-1.172.936-1.76-2.218H3.5a1 1 0 01-1-.993zM3.25 3a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/service/ic_wheelchair_unknown.svg";